import { Input } from "antd";
import React, { useEffect, useMemo, useRef } from "react";
import ComponentLabel from "../../ControlComponents/ComponentLabel";
import { Col } from "react-bootstrap";
import { Controller } from "react-hook-form";

import ThaiBahtText from 'thai-baht-text'
import _, { debounce } from "lodash";

type InputFormProps = {
  template: any;
  data?: any;
  rowIdx: number;
  colIdx: number;
  col?: any;
  colText?: number;
  colAction?: number;
  name: string;
  control: any;
  canEditDoc: boolean;
  checkActionPage: string;
  buttonType: string;
  getValues?: any;
  onControlChange: (
    controlTemplate: any,
    controlValue: any,
    controlUpdate: any
  ) => any;
};

export const NumberToBahtComponent: React.FC<InputFormProps> = ({
  colIdx,
  rowIdx,
  control,
  name,
  data,
  template,
  col,
  colAction,
  colText,
  canEditDoc,
  checkActionPage,
  buttonType,
  getValues,
  onControlChange,
  ...props
}) => {
  const inputRef = useRef(null)
  let inpId = template.label.replaceAll(" ", "_");

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        let inpId = template.label.replaceAll(" ", "_");
        return (
          <>
            <ComponentLabel
              col={col}
              colText={colText}
              rowIdx={rowIdx}
              colIdx={rowIdx}
              template={template}
            />
            <Col
              sm={col === undefined ? 12 : 12}
              md={col === undefined ? colAction : 12}
              xs={col === undefined ? 12 : 12}
              xl={col === undefined ? colAction : 12}
              className={"padding-controller"}
            >
              <div
                className={`input-component-container`}
              >
                <Input
                  {...field}
                  id={inpId}
                  value={ field.value}
                  readOnly={true}
                  size={"large"}
                  className="input-component table-input"
                  disabled={true}
                />
              </div>
            </Col>
          </>
        );
      }}
    />
  );
};